import React , { useRef } from 'react';
import { useSelector} from 'react-redux';
import { About, Locale, Image, Description, TermsAndConditions} from '../../components/eventDetails';

const EventDetails = ({ isAdmin, activeSection, formattedDate, onChange, stateName, readOnly = false }) => {
  const { eventDetails: eventData, mongoId } = useSelector((state) => state[stateName || 'eventDashboard']);
  const { activeRequests } = useSelector((state) => state.app);


  const eventImagesRef = useRef(null);

  const renderContent = () => {
    switch (activeSection) {
    case 'about':
      return (
        <About formData={eventData} 
          onChange={onChange}
          isAdmin={isAdmin}
          readOnly={readOnly}
        />
      );
    case 'locale':
      return (
        <Locale formData={eventData}
          formattedDate={formattedDate}
          onChange={onChange}
          isAdmin={isAdmin}
          readOnly={readOnly}
        />
      );
    case 'image':
      return (
        <Image
          formData={eventData}
          onChange={onChange}
          isEventImageUploading={activeRequests?.includes('event-image-upload')}
          eventImagesRef={eventImagesRef}
          isAdmin={isAdmin}
          readOnly={readOnly}
          eventId={mongoId}
        />
      );
    case 'description':
      return (
        <Description
          formData={eventData}
          onChange={onChange}
          isAdmin={isAdmin}
          readOnly={readOnly}
        />
      );
    case 'note':
      return (
        <TermsAndConditions
          formData={eventData}
          onChange={onChange}
          isAdmin={isAdmin}
          readOnly={readOnly}
        />
      );
    default:
      return null;
    }
  };

  return (
    <div className='flex-1'>
      {renderContent()}
    </div>
  );
};

export default EventDetails;
